module.exports = __webpack_public_path__ + "img/[社会社会].2fa8f7da.svg";